import { fromAxiosNutsJson, NutsJson, webstore } from '@/api';
import { Contact } from '@/stores/customer';

interface CreateContactRequest {
  readonly email: string;
  readonly b2b?: boolean;
  readonly b2bSource?: 'cx checkout buying for business' | 'checkout buying for business';
  readonly reason?: string;
  readonly subscribed?: true | false | 'unchecked' | 'if-new';
  readonly jobTitle?: string;
}

export interface CreateSurveySubmissionsRequest {
  submissions: {
    answerId: string;
    openEndedResponse?: string;
  }[];
  email: string;
}

export async function createSurveySubmissions(request: CreateSurveySubmissionsRequest) {
  await fromAxiosNutsJson(
    webstore.sessionSpecific.post<NutsJson<void>>('/survey-submissions', request),
    { onMessages: 'default' },
  );
}

export async function createContact(request: CreateContactRequest) {
  await fromAxiosNutsJson(
    webstore.sessionSpecific.post<NutsJson<void>>('/api/contacts', request),
    {},
  );
}

export async function subscribe(email: string, firstName = '') {
  const formData = new FormData();
  formData.set('inputEmail', email);
  formData.set('inputFirstName', firstName);
  formData.set('detailsForm', '1');
  formData.set('reason', 'footer');
  const response = await fromAxiosNutsJson<NutsJson>(webstore.post('/subscribe', formData), {});

  return response;
}

export async function subscribeCustomer({
  attentiveSignUpSourceId,
  email,
  phone,
  reason,
}: {
  attentiveSignUpSourceId?: string;
  email: string;
  phone?: string;
  reason: string;
}) {
  const formData = new FormData();
  formData.set('email', email);
  if (phone) formData.set('phone', phone);
  formData.set('reason', reason);
  if (attentiveSignUpSourceId) formData.set('attentiveSignUpSourceId', attentiveSignUpSourceId);

  const response = await fromAxiosNutsJson<{
    contact?: Contact;
    existingCustomer: boolean;
    existingContact: boolean;
    success: boolean;
  }>(webstore.post('/subscribe/customer', formData), {});

  return response;
}
